import React, {useEffect, useState} from 'react';
import {Box} from '@spothero/ui';
import {Helmet} from 'react-helmet-async';
import {useDispatch, useSelector} from 'react-redux';
import SHLoader from 'common/loader';
import ReservationUtils from 'utils/reservation-utils';
import {
    fetchReservation,
    setError,
} from 'store/parking-pass/parking-pass-actions';
import {useRouteMatch} from 'react-router';
import PostPurchaseAuthError from 'common/post-purchase-auth-error';
import {PARKING_PASS} from 'common/post-purchase-auth-error/PostPurchaseAuthError';
import UserUtils from 'utils/user-utils';
import ParkingPassContent from './components/parking-pass-content';
import {getParkingPass} from 'store/parking-pass/parking-pass-selectors';
import PayPalProvider from 'common/paypal/paypal-provider';

const ParkingPass = () => {
    const {error: parkingPassError, isPending, data: reservation} = useSelector(
        getParkingPass
    );
    const {data: user} = useSelector(state => state.user);
    const [prevUserStatus, setPrevUserStatus] = useState(user.status);
    const dispatch = useDispatch();
    const routeMatch = useRouteMatch();
    const noReservationData =
        !reservation || Object.keys(reservation).length === 0;

    // Issues with checking for auth'd user when sending request from server, so if no access key, try again on client
    useEffect(() => {
        if (
            parkingPassError ===
                ReservationUtils.POST_PURCHASE_ERRORS_ENUM.NO_ACCESS_KEY &&
            !isPending
        ) {
            if (user.status === UserUtils.AUTH_STATE.USER) {
                dispatch(
                    fetchReservation({reservationId: routeMatch.params.id})
                );
            } else {
                dispatch(
                    setError({
                        error:
                            ReservationUtils.POST_PURCHASE_ERRORS_ENUM
                                .ACCESS_DENIED,
                    })
                );
            }
        }
    }, [
        parkingPassError,
        isPending,
        dispatch,
        routeMatch.params.id,
        user.status,
    ]);

    // If user is loaded into state, try again to fetch reservation
    useEffect(() => {
        if (user.status !== prevUserStatus) {
            setPrevUserStatus(user.status);

            if (
                user.status === UserUtils.AUTH_STATE.USER &&
                Object.keys(reservation).length === 0 &&
                parkingPassError !==
                    ReservationUtils.POST_PURCHASE_ERRORS_ENUM.NO_ID
            ) {
                dispatch(
                    fetchReservation({reservationId: routeMatch.params.id})
                );
            }
        }
    }, [
        parkingPassError,
        user.status,
        dispatch,
        prevUserStatus,
        reservation,
        routeMatch.params.id,
    ]);

    if (
        isPending ||
        parkingPassError ===
            ReservationUtils.POST_PURCHASE_ERRORS_ENUM.NO_ACCESS_KEY
    ) {
        return (
            <Box as="main">
                <Helmet>
                    <meta name="robots" content="noindex, nofollow" />
                    <body className="standalone-page" />
                </Helmet>
                <SHLoader className="Checkout-loader" />
            </Box>
        );
    }

    if (parkingPassError || noReservationData) {
        return (
            <Box as="main">
                <Helmet>
                    <meta name="robots" content="noindex, nofollow" />
                    <body className="standalone-page" />
                </Helmet>
                <PostPurchaseAuthError
                    errorType={parkingPassError}
                    item={PARKING_PASS}
                />
            </Box>
        );
    }

    return (
        <PayPalProvider>
            <ParkingPassContent reservation={reservation} />
        </PayPalProvider>
    );
};

export default ParkingPass;
